"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Object2D_1 = require("engine/ui/Object2D");
var React = require("react");
var ReactObject = /** @class */ (function (_super) {
    __extends(ReactObject, _super);
    function ReactObject(content, w, h) {
        var _this = _super.call(this) || this;
        _this.render = false;
        _this.reactUid = ReactObject.uidCounter++;
        _this._content = content;
        if (w != null)
            _this.w = w;
        if (h != null)
            _this.h = h;
        return _this;
    }
    Object.defineProperty(ReactObject.prototype, "content", {
        get: function () { return this._content; },
        set: function (n) { this._content = n; this.eventEmitter.emit('setContent', n); },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Object.defineProperty(ReactObject.prototype, "containerStyle", {
        get: function () { return this._containerStyle; },
        set: function (style) { this._containerStyle = style; this.eventEmitter.emit('setContent', this._content); },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    ReactObject.prototype.addSetContentListener = function (listener) {
        this.eventEmitter.addListener('setContent', listener);
    };
    ReactObject.prototype.removeSetContentListener = function (listener) {
        this.eventEmitter.removeListener('setContent', listener);
    };
    ReactObject.prototype.addWorldTransformUpdatedListener = function (listener) {
        this.eventEmitter.addListener('worldTransformUpdated', listener);
    };
    ReactObject.prototype.removeWorldTransformUpdatedListener = function (listener) {
        this.eventEmitter.removeListener('worldTransformUpdated', listener);
    };
    ReactObject.prototype.applyWorldTransform = function (transform) {
        _super.prototype.applyWorldTransform.call(this, transform);
        this.eventEmitter.emit('worldTransformUpdated', this.worldTransformMat4, this.computedWidth, this.computedHeight);
    };
    ReactObject.uidCounter = 0;
    return ReactObject;
}(Object2D_1.default));
exports.ReactObject = ReactObject;
var ReactObjectContainer = /** @class */ (function (_super) {
    __extends(ReactObjectContainer, _super);
    function ReactObjectContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.updateTransformState = function (worldTransform, computedWidth, computedHeight) {
            _this.setState({
                worldTransform: worldTransform,
                computedWidth: computedWidth,
                computedHeight: computedHeight
            });
        };
        _this.updateContentState = function (content) {
            _this.setState({
                content: content
            });
        };
        var reactObjectInternal = props.reactObject;
        _this.state = {
            content: props.reactObject.content,
            worldTransform: reactObjectInternal.worldTransformMat4,
            computedWidth: reactObjectInternal.computedWidth,
            computedHeight: reactObjectInternal.computedHeight,
            style: props.reactObject.containerStyle,
        };
        return _this;
    }
    ReactObjectContainer.prototype.componentDidMount = function () {
        this.props.reactObject.addWorldTransformUpdatedListener(this.updateTransformState);
        this.props.reactObject.addSetContentListener(this.updateContentState);
    };
    ReactObjectContainer.prototype.componentWillUnmount = function () {
        this.props.reactObject.removeWorldTransformUpdatedListener(this.updateTransformState);
        this.props.reactObject.removeSetContentListener(this.updateContentState);
    };
    ReactObjectContainer.prototype.render = function () {
        var scene = this.props.scene;
        var w = this.state.worldTransform;
        // apply inverse scene transform to convert clips-space world coordinates to DOM pixels
        var x = (w[12] - scene.x) / scene.sx;
        var y = (w[13] - scene.y) / scene.sy;
        var z = (w[14] - scene.z) / scene.sz;
        var sx = w[0] / scene.sx;
        var sy = w[5] / scene.sy;
        var sz = w[10] / scene.sz;
        return React.createElement("div", { className: "react-object-container", style: __assign({}, this.state.style, { position: 'absolute', transform: "matrix3d(\n                    " + sx + " , 0     , 0     , 0 ,\n                    0     , " + sy + " , 0     , 0 ,\n                    0     , 0     , " + sz + " , 0 ,\n                    " + x + "  , " + y + "  , " + z + "  , 1\n                )", width: this.state.computedWidth, height: this.state.computedHeight }) }, this.state.content);
    };
    return ReactObjectContainer;
}(React.Component));
exports.ReactObjectContainer = ReactObjectContainer;
exports.default = ReactObject;
